import React from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'

import MomentosGeneralReport from './MomentosGeneralReport'
import StoresResellReport from './StoresResellReport'

export default function Momentos() {
	return (
		<React.Fragment>
			<Switch>
				<Route exact path="/momentos/recompra_total" render={() => (
					<MomentosGeneralReport reportType="recompra_total" />
				)} />
				
				<Route exact path="/momentos/gestion_email_marketing" render={() => (
					<MomentosGeneralReport reportType="gestion_email_marketing" />
				)} />
				
				<Route exact path="/momentos/gestion_cumpleanos" render={() => (
					<MomentosGeneralReport reportType="gestion_cumpleanos" />
				)} />

				<Route exact path="/momentos/gestion_tiendas" render={() => (
					<MomentosGeneralReport reportType="gestion_tiendas" />
				)} />

				<Route exact path="/momentos/gestion_sms_marketing" render={() => (
					<MomentosGeneralReport reportType="gestion_sms_marketing" />
				)} />

				<Route exact path="/momentos/organico" render={() => (
					<MomentosGeneralReport reportType="organico" />
				)} />

				<Route exact path="/momentos/recompra_fiel_tiendas" render={() => (
					<StoresResellReport reportType="recompra_fiel_tiendas" />
				)} />

				<Redirect to="/404" />
			</Switch>
		</React.Fragment>
	)
}